/** The red asterisk that marks a mandatory field; put it inside the label, after the label text. */
export function RequiredMark() {
  return (
    <span className="text-red" aria-hidden="true">
      *
    </span>
  );
}
